module.exports = __webpack_public_path__ + "static/media/Rate.7b768803.svg";